import Vue from 'vue'
import store from '../store/store'

const TokenKey = 'Admin-Token'

export function getToken() {

  let token = "";
  token = store.state.common.token;
  return token;

}

export function setToken(token) {
  if (token) {
    store.dispatch("common/setToken", token);
  } else {
    console.log("超时刷新");
    // location.reload();
    // 如果没有token ，重新获取，并刷新，获取不到当前路由，待解决
    // router.replace(router.history.current.fullPath);
  }
}

export function removeToken() {
  store.dispatch("common/setToken", "");
}



// WEBPACK FOOTER //
// ./utils/auth.js